import { ConfigMeasurementUnit } from '@mri/types';

type ConvertUnitProd = {
  value: number | string;
  units: Array<ConfigMeasurementUnit>;
  selectUnit: string;
}

export function toUnit(prop: ConvertUnitProd): number{
  const {selectUnit, units, value } = prop;

  const unitConfig = units
    .find( u => u.key === selectUnit);

  if(!unitConfig) return Number(value);

  return Number(value) * unitConfig.multiply;
}